import React, { useState } from 'react';
import useTranslate from '../../../../hooks/utils/useTranslate';
import languages from '../../../../helpers/utils/languages';
import { Box, Button, Typography } from '@mui/material';
import { MonoFilterSelect } from './MonoFilterSelect';
import TranslateIcon from '@mui/icons-material/Translate';
import useTranslateText from '../../../../hooks/utils/useTranslateText';

export const TranslateTemplate = ({ subject, content, changeContent }) => {
  const [translateTo, setTranslateTo] = useState({});
  const { translateText } = useTranslate({
    content: content || { content: [{ type: 'doc' }] },
    target: translateTo?.code || 'EN',
  });
  const { translateString } = useTranslateText({
    text: subject || '',
    target: translateTo?.code || 'EN',
  });
  const languageSelect = languages?.map((item) => {
    const value = (
      <Typography>
        <span className={`fi fi-${item?.flag}`} /> - {item?.lang}
      </Typography>
    );
    return { label: item?.lang, id: item?.code2, display: value };
  });

  const handleTranslate = async () => {
    const { translatedText } = await translateText({
      content: content,
      target: translateTo?.code,
    });
    const { translatedString } = await translateString({
      text: subject || '',
      target: translateTo?.code,
    });
    changeContent({ subject: translatedString, body: translatedText });
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 3,
      }}
    >
      <TranslateIcon sx={{ margin: 1 }} color="primary" />
      <Box
        sx={{
          minWidth: '25%',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <MonoFilterSelect
          props={{ minWidth: '100%' }}
          options={languageSelect}
          setFormData={setTranslateTo}
          dataField={'code'}
        />
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleTranslate}
        disabled={!translateTo?.code}
      >
        Traduire
      </Button>
    </Box>
  );
};
